































































































































import { Component, Vue } from 'vue-property-decorator';
import BillEditor, { BillEditType } from '@/components/bill/billEditor.vue';
import { BillData, BillItemData, BillItemGroup, BillSettings } from '@/models/billData';
import { BillTypes } from '@/enums/billTypes';
import { getGradeYearName, GradeYears } from '@/enums/gradeYears';
import Axios from 'axios';
import { BillResponse, BillStudentsResponse } from '@/models/billResponse';
import { Person } from '@/models/person';
import { SubmitArgs as StudentSelectedArgs } from '@/components/student/studentSelectDialog.vue';
import { PaymentStatusTypes } from '@/enums/paymentStatusTypes';
import moment from 'moment';
import { BillItemsResponse } from '@/models/billItemResponse';
import { BillRequest, BulkCreateBillRequest } from '@/models/billRequest';
import { Route } from 'vue-router';
import { BillStatusTypes } from '@/enums/billStatusTypes';
import { KeyValuePair } from '@/models/keyValuePair';
import { BillTemplateResponse, BillTemplateSummariesResponse } from '@/models/billTemplateResponse';
import DialogWrapper from '@/components/dialogWrapper.vue';
import { PeriodicBillResponse } from '@/models/periodicBillResponse';
import AvaivaledVue from '@/components/avaivaled.vue';
import { FunctionTypes } from '@/enums/functionTypes';
import { CollectionAgencyTypes } from '@/enums/collectionAgencyTypes';

interface ValidData extends BillData {
  validateOK: boolean;
}

@Component({
  components: {
    BillEditor
  }
})
export default class BillEdit extends AvaivaledVue {
  public BillEditType = BillEditType;
  public getGradeYearName = getGradeYearName;
  public billList: BillData[] = [];
  public billTemplates: Array<KeyValuePair<string, string>> = [];
  public billTemplateId: string = '';
  public beforeBillTemplateId: string = '';

  private isEdit: boolean = false;
  private studentSelectVisible = false;
  private billGradeYearReflection = false;

  get initBillData(): BillData {
    return {
      billId: '',
      studentId: '',
      studentUserId: '',
      studentName: '(生徒氏名)',
      gradeYear: GradeYears.All,
      billGradeYear: GradeYears.All,
      title: '',
      billNo: '',
      billDate: null,
      billDateCreationMonth: null,
      billDateCreationDay: 1,
      billMessage: '',
      contactInfo: '',
      billType: BillTypes.None,
      billExplanation: '',
      billLimitDate: null,
      billLimitDateCreationMonth: null,
      billLimitDateCreationDay: 31,
      taxRate: 10,
      taxType: this.billSettings.taxType,
      taxRoundType: this.billSettings.taxRoundType,
      billStatus: BillStatusTypes.Unbilled,
      billStatusUpdatedAt: null,
      paymentStatus: PaymentStatusTypes.Unpaid,
      paymentStatusUpdatedAt: null,
      items: [],
      periodicBillId: null,
    };
  }

  get pageTitle() {
    return this.isEdit
      ? '請求書編集'
      : '請求書登録';
  }

  get selectedStudents(): Person[] {
    return this.billList.map((bill) => ({
      id: bill.studentId,
      name: bill.studentName
    }));
  }

  get billSettings(): BillSettings {
    return this.$store.state.bill.billSettings;
  }

  get billItemGroups(): BillItemGroup[] {
    return this.$store.state.bill.billItemGroups;
  }

  get collectionAgency(): CollectionAgencyTypes {
    if (!this.user || !this.user.collectionAgency) {
      return CollectionAgencyTypes.None;
    }
    return this.user.collectionAgency;
  }

  public async created() {
    const ok = await this.pageBackCheck(FunctionTypes.Bill);
    if (!ok) {
      return;
    }

    try {
      await this.$store.dispatch('bill/fetchBillSettings');
      await this.$store.dispatch('bill/fetchBillItems');
    } catch (error) {
      //
    }

    try {
      const res = await Axios.get<BillTemplateSummariesResponse>('/api/bill-templates/summaries');
      const resData = res.data;

      this.billTemplates = resData.billTemplates
        .map((template) => ({
          key: template.billTemplateId,
          value: template.templateName,
        }));
      this.billTemplates.splice(0, 0, {
        key: '',
        value: '未指定'
      });
    } catch (error) {
      //
    }

    const billId = this.$route.params.billId;
    if (billId) {
      const page = String(this.$route.name);
      this.isEdit = (page.toUpperCase() === 'BillEdit'.toUpperCase());

      try {
        const res = await Axios.get<BillResponse>(`/api/bills/${billId}`);
        const resData = res.data;
        this.billList = [
          {
            billId: resData.billId,
            studentId: resData.studentId,
            studentUserId: resData.studentUserId,
            studentName: resData.studentName,
            gradeYear: resData.gradeYear,
            billGradeYear: resData.billGradeYear,
            billNo: resData.billNo,
            title: resData.title,
            billDate: !resData.billDate ? null : moment(resData.billDate).toDate(),
            billDateCreationMonth: null,
            billDateCreationDay: 1,
            billMessage: resData.billMessage,
            contactInfo: resData.contactInfo,
            billType: resData.billType,
            billExplanation: resData.billExplanation,
            billLimitDate: !resData.billLimitDate ? null : moment(resData.billLimitDate).toDate(),
            billLimitDateCreationMonth: null,
            billLimitDateCreationDay: 31,
            taxRate: resData.taxRate,
            taxType: this.isEdit ? resData.taxType : this.billSettings.taxType,
            taxRoundType: this.isEdit ? resData.taxRoundType : this.billSettings.taxRoundType,
            billStatus: resData.billStatus,
            billStatusUpdatedAt: resData.billStatusUpdatedAt as Date,
            paymentStatus: resData.paymentStatus,
            paymentStatusUpdatedAt: resData.paymentStatusUpdatedAt as Date,
            items: resData.billDetails.map((value) => ({
              isFree: value.isFree,
              groupType: value.groupType,
              groupName: value.groupName,
              itemId: value.itemId,
              itemName: value.itemName,
              unitPrice: value.unitPrice,
              quantity: value.quantity,
              discountOfPercent: value.discountOfPercent,
              nonTaxable: value.nonTaxable,
            })),
            periodicBillId: resData.periodicBillId,
          }
        ];

        if (!this.isEdit) {
          const billData = this.billList[0];
          billData.billId = '';
          billData.billNo = '';
          billData.billStatus = BillStatusTypes.Unbilled;
          billData.billStatusUpdatedAt = null;
          billData.paymentStatus = PaymentStatusTypes.Unpaid;
          billData.paymentStatusUpdatedAt = null;
        }
      } catch (error) {
        this.$router.push({ name: 'BillList' });
        return;
      }
    } else if (this.$route.query['periodic-id']) {
      try {
        const periodicIds = this.$route.query['periodic-id'].toString().split(',');

        this.billList = [];
        for (const periodicId of periodicIds) {
          const res = await Axios.get<PeriodicBillResponse>(`/api/periodic-bills/${periodicId}`);
          const resData = res.data;

          let billDate: Date | null = null;
          if (resData.billDateCreationMonth !== null) {
            billDate = new Date();
            billDate.setDate(1);

            billDate.setMonth(billDate.getMonth() + resData.billDateCreationMonth);
            const month = billDate.getMonth();

            billDate.setDate(resData.billDateCreationDay);

            if (billDate.getMonth() > month) {
              // 次の月に繰り上がった為、前の月の月末にする
              billDate.setDate(0);
            }
          }

          let billLimitDate: Date | null = null;
          if (resData.billLimitDateCreationMonth !== null) {
            billLimitDate = new Date();
            billLimitDate.setDate(1);

            billLimitDate.setMonth(billLimitDate.getMonth() + resData.billLimitDateCreationMonth);
            const month = billLimitDate.getMonth();

            billLimitDate.setDate(resData.billLimitDateCreationDay);

            if (billLimitDate.getMonth() > month) {
              // 次の月に繰り上がった為、前の月の月末にする
              billLimitDate.setDate(0);
            }
          }

          this.billList.push({
            billId: '',
            studentId: resData.studentId,
            studentUserId: resData.studentUserId,
            studentName: resData.studentName,
            gradeYear: resData.gradeYear,
            billGradeYear: resData.gradeYear,
            billNo: resData.billNo,
            title: resData.title,
            billDate,
            billDateCreationMonth: null,
            billDateCreationDay: 1,
            billMessage: resData.billMessage,
            contactInfo: resData.contactInfo,
            billType: resData.billType,
            billExplanation: resData.billExplanation,
            billLimitDate,
            billLimitDateCreationMonth: null,
            billLimitDateCreationDay: 31,
            taxRate: resData.taxRate,
            taxType: this.billSettings.taxType,
            taxRoundType: this.billSettings.taxRoundType,
            billStatus: BillStatusTypes.Unbilled,
            billStatusUpdatedAt: null,
            paymentStatus: PaymentStatusTypes.Unpaid,
            paymentStatusUpdatedAt: null,
            items: resData.periodicBillDetails.map((value) => ({
              isFree: false,
              groupType: value.groupType,
              groupName: '',
              itemId: value.itemId,
              itemName: '',
              unitPrice: 0,
              quantity: value.quantity,
              discountOfPercent: value.discountOfPercent,
              nonTaxable: value.nonTaxable,
            })),
            periodicBillId: resData.periodicBillId,
          });
        }

        const page = String(this.$route.name);
        this.isEdit = (page.toUpperCase() === 'BillEdit'.toUpperCase());
        if (!this.isEdit) {
          const billData = this.billList[0];
          billData.billId = '';
          billData.billNo = '';
          billData.billStatus = BillStatusTypes.Unbilled;
          billData.billStatusUpdatedAt = null;
          billData.paymentStatus = PaymentStatusTypes.Unpaid;
          billData.paymentStatusUpdatedAt = null;
        }
      } catch (error) {
        this.$router.push({ name: 'BillList' });
        return;
      }
    } else {
      this.billList = [];
      this.studentSelectVisible = true;
    }
  }

  private deactivated() {
    this.$destroy();
  }

  private async onSubmitSelectedStudents(args: StudentSelectedArgs) {
    const selectedStudents = args.selectedStudents;
    if (!selectedStudents || selectedStudents.length === 0) {
      args.cancelClose = true;
      return;
    }

    const selectedBills = this.billList.filter((item) => {
      return !!selectedStudents.find((selectedItem) => {
        return selectedItem.id ===  item.studentId;
      });
    });

    const addStudentIds = selectedStudents.filter((item) => {
      return !selectedBills.find((bill) => {
        return bill.studentId === item.id;
      });
    }).map((item) => item.id);

    try {
      if (addStudentIds.length > 0) {
        const res = await Axios.post<BillStudentsResponse>('/api/bills/search-bill-students', {
          studentIds: addStudentIds,
        });

        res.data.billStudents.forEach((student) => {
          selectedBills.push({
            ...JSON.parse(JSON.stringify(this.initBillData)),
            studentId: student.studentId,
            studentUserId: student.studentUserId,
            studentName: student.studentName,
            gradeYear: student.gradeYear,
            billGradeYear: student.gradeYear,
          });
        });
      }
      this.billList = selectedBills;
    } catch (error) {
      this.$router.push({ name: 'BillList' });
    }
  }

  private onCancelSelectedStudents() {
    if (this.billList.length === 0) {
      this.$router.push({ name: 'BillList' });
    }
  }

  private async onBillTemplateChange() {
    try {
      await this.$confirm('テンプレートを変更すると入力情報がクリアされます。よろしいですか？');

      await this.refrectBillTemplateToBillList();

      this.beforeBillTemplateId = this.billTemplateId;
    } catch (error) {
      this.billTemplateId = this.beforeBillTemplateId;
    }
  }

  private async refrectBillTemplateToBillList() {
    if (this.billTemplateId) {
      const res = await Axios.get<BillTemplateResponse>(`/api/bill-templates/${this.billTemplateId}`);
      const resData = res.data;

      const details: BillItemData[] = resData.billTemplateDetails.map((item) => ({
        isFree: false,
        groupType: item.groupType,
        groupName: '',
        itemId: item.itemId,
        itemName: '',
        unitPrice: 0,
        quantity: item.quantity,
        discountOfPercent: item.discountOfPercent,
        nonTaxable: item.nonTaxable,
      }));

      this.billList.forEach((billData) => {
        let billDate: Date | null = null;
        if (resData.billDateCreationMonth !== null) {
          billDate = new Date();
          billDate.setDate(1);

          billDate.setMonth(billDate.getMonth() + resData.billDateCreationMonth);
          const month = billDate.getMonth();

          billDate.setDate(resData.billDateCreationDay);

          if (billDate.getMonth() > month) {
            // 次の月に繰り上がった為、前の月の月末にする
            billDate.setDate(0);
          }
        }

        let billLimitDate: Date | null = null;
        if (resData.billLimitDateCreationMonth !== null) {
          billLimitDate = new Date();
          billLimitDate.setDate(1);

          billLimitDate.setMonth(billLimitDate.getMonth() + resData.billLimitDateCreationMonth);
          const month = billLimitDate.getMonth();

          billLimitDate.setDate(resData.billLimitDateCreationDay);

          if (billLimitDate.getMonth() > month) {
            // 次の月に繰り上がった為、前の月の月末にする
            billLimitDate.setDate(0);
          }
        }

        billData.title = resData.title;
        billData.billDate = billDate;
        billData.billMessage = resData.billMessage;
        billData.contactInfo = resData.contactInfo;
        billData.billType = resData.billType;
        billData.billExplanation = resData.billExplanation;
        billData.billLimitDate = billLimitDate;
        billData.taxRate = resData.taxRate;
        billData.items = JSON.parse(JSON.stringify(details));
      });
    } else {
      this.billList.forEach((billData) => {
        billData.title = '';
        billData.billDate = null;
        billData.billMessage = '';
        billData.contactInfo = '';
        billData.billType = BillTypes.None;
        billData.billExplanation = '';
        billData.billLimitDate = null;
        billData.taxRate = 10;
        billData.items = [];
      });
    }

    const editors = this.$refs.editor as BillEditor[];
    editors.forEach((editor) => {
      editor.refrectDetails();
    });

    this.$nextTick(() => {
      editors.forEach((editor) => {
        editor.clearValidateBillData();
      });
    });
  }

  private async onBulkEdit() {
    const form: ValidData = JSON.parse(JSON.stringify(this.initBillData));
    for (const key of Object.keys(form)) {
      const checkValue = (this.billList[0] as any)[key];
      const check = this.billList.findIndex((billData: any) => {
        if (key === 'items') {
          return JSON.stringify(billData[key]) !== JSON.stringify(checkValue);
        } else {
          return billData[key] !== checkValue;
        }
      }) < 0;
      if (check) {
        (form as any)[key] = checkValue;
      }
    }

    try {
      const result = await (this.$refs.billEdit as DialogWrapper).open({...form}) as BillData;

      this.$el.querySelector('.bulk-bill-edit-dialog')!.scrollTop = 0;

      const reflection = (this.$refs.bulkEdit as BillEditor).reflection;

      this.billList.forEach((billData) => {
        if (reflection.title) {
          billData.title = result.title;
        }
        if (reflection.billDate) {
          billData.billDate = result.billDate;
        }
        if (reflection.billMessage) {
          billData.billMessage = result.billMessage;
        }
        if (reflection.contactInfo) {
          billData.contactInfo = result.contactInfo;
        }
        if (reflection.billType) {
          billData.billType = result.billType;
        }
        if (reflection.billExplanation) {
          billData.billExplanation = result.billExplanation;
        }
        if (reflection.billLimitDate) {
          billData.billLimitDate = result.billLimitDate;
        }
        if (reflection.taxRate) {
          billData.taxRate = result.taxRate;
        }
        if (reflection.items) {
          billData.items = JSON.parse(JSON.stringify(result.items));
        }
        if (this.billGradeYearReflection) {
          if (result.billGradeYear === GradeYears.All) {
            billData.billGradeYear = billData.gradeYear;
          } else {
            billData.billGradeYear = result.billGradeYear;
          }
        }
      });

      const editors = this.$refs.editor as BillEditor[];
      editors.forEach((editor) => {
        editor.refrectDetails();
      });

      this.$nextTick(() => {
        editors.forEach((editor) => {
          editor.clearValidateBillData();
        });
      });
    } catch (error) {
      this.$el.querySelector('.bulk-bill-edit-dialog')!.scrollTop = 0;
      return;
    }
  }

  private onPreview() {
    //
  }

  private onCancel() {
    this.$router.push({ name: 'BillList' });
  }

  private async onRegister() {
    let validError = false;
    const editors = this.$refs.editor as BillEditor[];
    for (const editor of editors) {
      const valid = await editor.validateBillData();
      if (!valid) {
        validError = true;
      }
    }

    if (validError) {
      this.$message.error('入力項目を確認してください。');
      return;
    }

    if (this.isEdit) {
      await this.updateBill();
    } else {
      await this.createBill();
    }
  }

  private async createBill() {
    try {
      await this.$confirm('請求書を作成します。よろしいですか？', {
        title: '請求書作成確認',
        confirmButtonText: '作成',
      });
    } catch (error) {
      return;
    }

    try {
      const req: BulkCreateBillRequest = {
        bills: this.billList.map((bill) => ({
          billId: bill.billId,
          studentId: bill.studentId,
          billGradeYear: bill.billGradeYear,
          title: bill.title,
          billNo: bill.billNo,
          billDate: bill.billDate!,
          billMessage: bill.billMessage,
          contactInfo: bill.contactInfo,
          billType: bill.billType,
          billExplanation: bill.billExplanation,
          billLimitDate: bill.billLimitDate!,
          taxRate: bill.taxRate,
          taxType: bill.taxType,
          taxRoundType: bill.taxRoundType,
          billStatus: bill.billStatus,
          billStatusUpdatedAt: bill.billStatusUpdatedAt,
          paymentStatus: bill.paymentStatus,
          paymentStatusUpdatedAt: bill.paymentStatusUpdatedAt,
          billDetails: bill.items.map((item) => ({
            seq: 0,
            sort: 0,
            isFree: item.isFree,
            groupType: item.groupType,
            groupName: item.groupName,
            itemId: item.itemId,
            itemName: item.itemName,
            unitPrice: item.unitPrice,
            quantity: item.quantity,
            discountOfPercent: item.discountOfPercent,
            nonTaxable: item.nonTaxable,
          })),
          periodicBillId: bill.periodicBillId,
        })),
      };
      const res = await Axios.post('/api/bills/bulk-create', req);
      if (res.status === 200) {
        this.$notify.success({
          title: '請求書作成完了',
          message: '請求書を作成しました。',
          position: 'bottom-right'
        });
        this.$router.push({ name: 'BillList' });
      }
    } catch (error) {
      this.$notify.error({
        title: '請求書作成エラー',
        message:
          (error.response && error.response.data) || '請求書の作成が失敗しました。',
        position: 'bottom-right'
      });
    }
  }

  private async updateBill() {
    try {
      await this.$confirm('請求書を更新します。よろしいですか？', {
        title: '請求書更新確認',
        confirmButtonText: '更新',
      });
    } catch (error) {
      return;
    }

    try {
      const bill = this.billList[0];
      const req: BillRequest = {
        billId: bill.billId,
        studentId: bill.studentId,
        billGradeYear: bill.billGradeYear,
        title: bill.title,
        billNo: bill.billNo,
        billDate: bill.billDate!,
        billMessage: bill.billMessage,
        contactInfo: bill.contactInfo,
        billType: bill.billType,
        billExplanation: bill.billExplanation,
        billLimitDate: bill.billLimitDate,
        taxRate: bill.taxRate,
        taxType: bill.taxType,
        taxRoundType: bill.taxRoundType,
        billDetails: bill.items.map((item) => ({
          seq: 0,
          sort: 0,
          isFree: item.isFree,
          groupType: item.groupType,
          groupName: item.groupName,
          itemId: item.itemId,
          itemName: item.itemName,
          unitPrice: item.unitPrice,
          quantity: item.quantity,
          discountOfPercent: item.discountOfPercent,
          nonTaxable: item.nonTaxable,
        })),
        periodicBillId: bill.periodicBillId,
      };
      const res = await Axios.put(`/api/bills/${bill.billId}`, req);
      if (res.status === 200) {
        this.$notify.success({
          title: '請求書更新完了',
          message: '請求書を更新しました。',
          position: 'bottom-right'
        });
        this.$router.push({ name: 'BillList' });
      }
    } catch (error) {
      this.$notify.error({
        title: '請求書更新エラー',
        message:
          (error.response && error.response.data) || '請求書の更新が失敗しました。',
        position: 'bottom-right'
      });
    }
  }
}
